// removed by extract-text-webpack-plugin
module.exports = {"itemValue":"G9478aa","itemRecipes":"G1a4dbd","itemSkip":"Gbcded7","itemDietary":"Gc7a1a9"};